/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("addOrEditTwoTagModule", []).
controller("addOrEditTwoTagCtrl", ["$scope", "$modalInstance","tagId","tagName","parentId","channelId","httpService","modalDialog", function($scope, $modalInstance,tagId,tagName,parentId,channelId,httpService,modalDialog) {
    initStatus();
    function initStatus() {
        $scope.status = {
        	
        };
        $scope.data = {
        	id : tagId,
        	tagName : tagName,
        	parentId : parentId,
        	oldName : tagName,
        };
    }
    $scope.confirm = function() {
    	if($scope.data.oldName != $scope.data.tagName){
			httpService.http("/mcnadmin/admin/tag/tagExistsValid.do",{tagName:$scope.data.tagName,tagId:$scope.data.parentId,channelId:channelId}, "post").then(function(data) {
				if(data.status === 'n'){
					modalDialog.alertType('','标签名已经存在','info')
				}else{
					$modalInstance.close($scope.data);
				}
			});
		}else{
			$modalInstance.close($scope.data);
		}
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
}]);